export default {
  Community: {
    title: "Қауымдастық",
    description:
      "Клиникалық жағдайлар бойынша дәрігерлер арасындағы білім алмасу",
    all_cases: "Барлық кейстер",
    my_cases: "Менің кейстерім",
    case: {
      shareLink: {
        1: "Кейсті қараңыз",
        2: "Платформада “" + process.env.VUE_APP_INSTALL_NAME + "”:",
      },
    },
  },
  h1_community: "Дәрігерлер қауымдастығы",
};
